export default function animatedHeadlineWidget(editor) {
  editor.DomComponents.addType('eb-animated-headline', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-animated-headline'
    },
    model: {
      defaults: {
        name: 'Animated Headline',
        tagName: 'div',
        droppable: false,
        attributes: {
          'data-gjs-type': 'eb-animated-headline',
          'data-words': 'Creative,Amazing,Powerful,Beautiful',
        },
        style: {
          'text-align': 'center',
          'padding': '30px 20px',
        },
        components: `
          <h2 style="font-size:36px;font-weight:700;color:#333;margin:0;">
            This is <span style="color:#667eea;border-bottom:3px solid #667eea;padding-bottom:2px;">Creative</span>
          </h2>
        `,
        traits: [
          { type: 'text', name: 'data-before-text', label: 'Before Text', placeholder: 'This is' },
          { type: 'text', name: 'data-words', label: 'Rotating Words (comma-separated)', changeProp: true },
          { type: 'text', name: 'data-after-text', label: 'After Text' },
          { type: 'select', name: 'data-animation', label: 'Animation', options: [
            { id: 'typing', label: 'Typing' },
            { id: 'fade', label: 'Fade' },
            { id: 'slide', label: 'Slide Up' },
          ]},
        ],
      },
      toHTML() {
        const attrs = this.getAttributes()
        const before = attrs['data-before-text'] || 'This is'
        const words = attrs['data-words'] || 'Creative,Amazing,Powerful'
        const after = attrs['data-after-text'] || ''
        const anim = attrs['data-animation'] || 'typing'
        const style = this.getStyle()
        const styleStr = Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';')
        const wordList = words.split(',').map(w => w.trim()).filter(Boolean)
        return `<div data-gjs-type="eb-animated-headline" style="${styleStr}">
          <h2 style="font-size:36px;font-weight:700;color:#333;margin:0;">
            ${before} <span class="eb-ah-word" style="color:#667eea;">${wordList[0] || ''}</span> ${after}
          </h2>
          <script>
          (function(){var el=document.currentScript.parentElement.querySelector('.eb-ah-word');var words=${JSON.stringify(wordList)};var i=0;var anim='${anim}';function next(){i=(i+1)%words.length;if(anim==='fade'){el.style.opacity='0';setTimeout(function(){el.textContent=words[i];el.style.opacity='1';},300);}else if(anim==='slide'){el.style.transform='translateY(-100%)';el.style.opacity='0';setTimeout(function(){el.textContent=words[i];el.style.transform='translateY(0)';el.style.opacity='1';},300);}else{el.textContent='';var w=words[i],ci=0;var t=setInterval(function(){ci++;el.textContent=w.slice(0,ci);if(ci>=w.length)clearInterval(t);},60);}}el.style.transition='opacity 0.3s,transform 0.3s';setInterval(next,3000);})();
          <\\/script>
        </div>`
      },
    },
  })

  editor.BlockManager.add('eb-animated-headline', {
    label: 'Animated Headline',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5,4V7H10.5V19H13.5V7H19V4H5Z"/></svg>',
    content: { type: 'eb-animated-headline' },
  })
}
